'use client'

import { Box, HTMLChakraProps, useBreakpointValue } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

export default function CommonContainer({
  children,
  className,
  ...rest
}: PropsWithChildren<HTMLChakraProps<"div"> &{
  className?: string
}>) {
  const isMdScreen = useBreakpointValue({
    base: true,
    dxl: false,
  });

  return (
    <Box className={className} w="full" px={isMdScreen ? '24px' : '96px'} {...rest}>
      {children}
    </Box>
  )
}